<template>
  <div v-if="hotspot.title" class="hotspotbox">
    <article class="media">
      <figure class="media-left" @click="onThumbnail(hotspot)">
        <p class="image">
          <img :src="hotspot.imageUrl" />
        </p>
      </figure>
      <div class="media-content">
        <div class="content">
          <h5 v-if="hotspot">{{ hotspot.title }}</h5>
          <p v-if="hotspot">{{ hotspot.info }}</p>

          <b-button
            v-for="doc in hotspot.docs"
            :key="doc.id"
            class="fas"
            :class="getClass(doc)"
            @click="onDocs(doc)"
            >&nbsp;&nbsp;{{ doc.name }}</b-button
          >
        </div>
      </div>
      <b-button class="fas fa-times close-button" @click="onClose()" />
    </article>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'HotspotBox',
  props: {
    hotspotConent: Object
  },
  methods: {
    getClass(doc) {
      if (doc.type == 'video') {
        return 'fa-play'
      } else if (doc.type == 'pdf') {
        return 'fa-file-pdf'
      } else if (doc.type == 'animation') {
        return 'fa-circle-notch'
      } else if (doc.type == 'web') {
        return 'fa-external-link-alt'
      }
    },
    onHotspotIsActive() {
      let hotspotBox = document.getElementsByClassName('hotspotbox')[0]
      hotspotBox.classList.add('active')

      let hotspotBoxHeight = hotspotBox.offsetHeight
      if (hotspotBoxHeight > window.innerHeight) {
        hotspotBox.classList.add('scrollable')
      }
    },
    onDocs(doc) {
      if (doc.type == 'video') {
        this.showModal({ component: 'VideoModal', data: doc })
      } else if (doc.type == 'pdf' || doc.type == 'web') {
        window.open(doc.url, '_blank')
        // this.showModal({ component: 'PdfModal', data: doc })
      } else if (doc.type == 'animation') {
        this.showModal({ component: 'GifAnimationModal', data: doc })
      }
    },
    onThumbnail(hotspot) {
      this.showModal({ component: 'ImageModal', data: hotspot })
    },
    onClose() {
      let hotspotBox = document.getElementsByClassName('hotspotbox')[0]
      hotspotBox.classList.remove('active')
      setTimeout(() => {
        this.$store.commit('hotspot/SET_HOTSPOT', {})
      }, 300)
    },
    ...mapMutations('modal', ['showModal'])
  },
  computed: {
    ...mapState('hotspot', ['hotspot'])
  },
  watch: {
    hotspot() {
      if (this.hotspot.title) {
        setTimeout(() => {
          this.onHotspotIsActive()
        }, 50)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
